import {
  httpGet,
  httpPost,
  httpPut,
  httpPatch,
  httpDelete,
} from "@/request/http";

let path = "/devices";

export default {
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  gets(businessId, dTO) {
    return httpGet(`/businesses/${businessId}/devices`, dTO);
  },
  save(item) {
    return httpPost(path, item);
  },
  put(item) {
    return httpPut(`${path}/${item.DeviceId}`, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  getReceivablePages(dTO) {
    return httpGet(`${path}/receivables/pages`, dTO);
  },
  getElecInvoice(id) {
    return httpGet(`${path}/${id}/elecinvoice`);
  },
  saveElecInvoice(item) {
    return httpPost(`${path}/elecinvoice`, item);
  },
  deleteElecInvoice(id) {
    return httpDelete(`${path}/${id}/elecinvoice`);
  },
  getElecInvoiceVerify(item) {
    return httpPost(`${path}/elecinvoice/verify`, item);
  },
  getOnlineOrder(id) {
    return httpGet(`${path}/${id}/onlineorder`);
  },
  updateOnlineOrder(id, dTO) {
    return httpPatch(`${path}/${id}/onlineorder`, dTO);
  },
  getLogo(id) {
    return httpGet(`${path}/${id}/onlineorder/logoImage`, null, {
      responseType: "blob",
    });
  },
  saveLogo(id, formData) {
    return httpPut(`${path}/${id}/onlineorder/logoImage`, formData);
  },
  removeLogo(id) {
    return httpDelete(`${path}/${id}/onlineorder/logoImage`);
  },
  getByUser() {
    return httpGet(`${path}/byuser`);
  },
  getOnlineOrderImg(id) {
    return httpGet(`${path}/${id}/onlineorder/image`, null, {
      responseType: "blob",
    });
  },
  saveOnlineOrderImg(id, formData) {
    return httpPut(`${path}/${id}/onlineorder/image`, formData);
  },
  removeOnlineOrderImg(id) {
    return httpDelete(`${path}/${id}/onlineorder/image`);
  },
  changeDevice(id, item) {
    return httpPost(`${path}/${id}/change-device`, item);
  },
  removeKDSServer(id) {
    return httpDelete(`${path}/${id}/KDSServer/delete`);
  },
  getApiKeys(id) {
    return httpGet(`${path}/${id}/credentials`);
  },
};
